import React from 'react';
import './Button.css';
import { Link } from 'react-router-dom';

export function Button({user,onClick}) {

 //console.log(user,onclick);

  return (
    <>

    {user ? <Link to='logout'>
      <div className='d-none d-lg-block d-xl-block' >
      <button className='btn-custom m-2'
      onClick = {onClick}
      >Sign out</button> 
      </div>
     
    </Link> : <Link to='login'>
      <div  className='d-none d-lg-block d-xl-block'>
      <button className='btn-custom  m-2'
    
      >Sign In</button> 
      </div>
     
    </Link>  }
    </>
  );
}
